'use client';

import { toValidMxpPath } from '@modules/prism/lib/mxp365/paths';
import { useEffect, useRef } from 'react';

import { createMxp365OpenEvent } from './events';

import type { Locale } from '@tuic/i18n';

type Props = {
  mxpToken: string | undefined;
  locale: Locale;
};

export const Mxp365DeeplinkHandler = ({ mxpToken, locale }: Props) => {
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current || !mxpToken) return;

    const searchParams = new URLSearchParams(window.location.search);
    const mxpParam = searchParams.get('mxp');
    if (!mxpParam) return;

    handled.current = true;

    // Clean ?mxp= from URL
    searchParams.delete('mxp');
    const newQueryString = searchParams.toString();
    const url = newQueryString
      ? `${window.location.pathname}?${newQueryString}`
      : window.location.pathname;
    window.history.replaceState({}, document.title, url);

    // Build path from the mxp param (same as Mxp365Link does)
    const path = toValidMxpPath(mxpParam);

    // Dispatch event to open the MXP dialog (same event Mxp365Link dispatches on click)
    window.dispatchEvent(
      createMxp365OpenEvent({
        path,
        title: 'MXP365',
        token: mxpToken,
        queryParams: {
          culture: locale === 'de' ? 'de-DE' : 'en-US',
          purchaseLocation: 'WEB',
        },
      }),
    );
  }, [mxpToken, locale]);

  return null;
};
